import { useEffect } from "react";

/**
 * SmoothScroll
 * Implements high-performance smooth scrolling via CSS scroll-behavior with
 * modal locking and reduced-motion compliance.
 *
 * (Note: The npm lenis package includes uncompiled ES class fields in .mjs
 * which cannot be parsed by CRA Webpack 4. Per prompt strict rules:
 * "If a smoothing technique causes problems, drop it and use CSS smooth scroll instead, and tell me why.")
 */
function SmoothScroll({ isPaletteOpen }) {
  useEffect(() => {
    const root = document.documentElement;

    const prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReducedMotion) {
      root.style.scrollBehavior = "auto";
    } else {
      root.style.scrollBehavior = "smooth";
    }

    // Stop / Lock scrolling while Command Palette is open
    if (isPaletteOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isPaletteOpen]);

  return null;
}

export default SmoothScroll;
